import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddCatalogue = () => {
    const [category_id, setCategoryId] = useState('');
    const [sub_category_id, setSubCategoryId] = useState('');
    const [image, setImage] = useState(null);
    const [weight, setWeight] = useState('');
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetchCategories();
        fetchSubCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await fetch(`${BASE_URL}categories`);
            const data = await response.json();
            if (data.status === 1) {
                setCategories(data.data); // Set categories data
            } else {
                alert('Failed to fetch categories');
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            alert('Error fetching categories');
        }
    };

    const fetchSubCategories = async () => {
        try {
            const response = await fetch(`${BASE_URL}subcategories`);
            const data = await response.json();
            if (data.status === 1) {
                setSubCategories(data.data); // Set subcategories data
            } else {
                alert('Failed to fetch subcategories');
            }
        } catch (error) {
            console.error('Error fetching subcategories:', error);
            alert('Error fetching subcategories');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic validation for empty fields
        if (!sub_category_id || !image || !weight) {
            setError('All fields are required');
            return;
        }

        const formData = new FormData();
        formData.append('category_id', 1); // Now sending dynamic category_id
        formData.append('sub_category_id', sub_category_id); // Now sending dynamic sub_category_id
        formData.append('image', image);
        formData.append('weight', 11);

        try {
            const response = await fetch(`${BASE_URL}catalogue/`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.status === 1) {
                alert('Catalogue added successfully');
                navigate('/CatalogueList'); // Redirect to catalogue list page
            } else {
                setError('Failed to add catalogue');
            }
        } catch (error) {
            console.error('Error adding catalogue:', error);
            setError('An error occurred while adding the catalogue');
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <h3>Add Forming Catalogue</h3>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-6 offset-md-3">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Error Message */}
                                    {error && <div className="alert alert-danger">{error}</div>}

                                    {/* Category Dropdown */}
                                    {/* <div className="mb-3">
                                        <label htmlFor="category_id" className="form-label">Category</label>
                                        <select
                                            id="category_id"
                                            className="form-control"
                                            value={category_id}
                                            onChange={(e) => setCategoryId(e.target.value)}
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map((category) => (
                                                <option key={category.id} value={category.name}>
                                                    {category.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div> */}

                                    {/* Subcategory Dropdown */}
                                    <div className="mb-3">
                                        <label htmlFor="sub_category_id" className="form-label">Sub Category</label>
                                        <select
                                            id="sub_category_id"
                                            className="form-control"
                                            value={sub_category_id}
                                            onChange={(e) => setSubCategoryId(e.target.value)}
                                        >
                                            <option value="">Select Subcategory</option>
                                            {subCategories.map((subcategory) => (
                                                <option key={subcategory.id} value={subcategory.id}>
                                                    {subcategory.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Image Upload */}
                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={(e) => setImage(e.target.files[0])}
                                        />
                                    </div>

                                    {/* Weight Input */}
                                    {/* <div className="mb-3">
                                        <label htmlFor="weight" className="form-label">Weight</label>
                                        <input
                                            type="text"
                                            id="weight"
                                            className="form-control"
                                            placeholder="Enter weight"
                                            value={weight}
                                            onChange={(e) => setWeight(e.target.value)}
                                        />
                                    </div> */}

                                    <button type="submit" className="btn btn-primary">Add Catalogue</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddCatalogue;
